import axios from 'axios';

export default {
    methods: {
        async presupuestoIndex(d, ok, err) {
            try {
                let r = await axios.get('presupuesto?page=' + d.page, {params: d});
                ok(r.data);
            } catch (e) {
                err(e);
            }
        },
        async presupuestoStore(d, ok, err) {
            try {
                let r = await axios.post('presupuesto', d)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoUpdate(d, ok, err) {
            try {
                let r = await axios.put('presupuesto/' + d.id, d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoShow(id, ok, err) {
            try {
                let r = await axios.get('presupuesto/' + id)
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async estadosListado(ok, err) {
            try {
                let r = await axios.get('presupuesto/estados/listado');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoCopia(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/copia', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoMoneda(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/moneda', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoPlazo(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/plazo', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoMios(ok, err) {
            try {
                let r = await axios.post('presupuesto/mios');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoMiosEstado(ok, err) {
            try {
                let r = await axios.post('presupuesto/mios-estado');
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoPedidos(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/pedidos', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoRemitos(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/remitos', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoFacturas(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/facturas', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoTotales(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/totales', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async presupuestoTotalObra(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/total-obra', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },        
        async presupuestoFleteRecalcula(d, ok, err) {
            try {
                let r = await axios.post('presupuesto/flete-recalcula', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/presupuesto.js